import clsx from "clsx"
import { FC } from "react"
import { MatchLogs } from "@/ui/MatchLogs"
import styles from "./GameMatchLogs.module.scss"

export const GameMatchLogs: FC = () => {
  return (
    <div className={clsx(styles.MatchLogsModal)}>
      <MatchLogs className={styles.MatchLogsModal_logs} isDesktop />
    </div>
  )
}
